import builder from '../builder';
import CreditCardLockAlternate from '../../streamline-icons/bold/credit-card-lock-alternate.svg';

export default builder(
  'IconCreditCardLockAlternateBold',
  CreditCardLockAlternate,
);
